export const SITE = {
  name: "Hammer Gym Studios",
  phoneDisplay: "076 335 38 28",
  phoneIntl: "+41 76 335 38 28",
  tel: "tel:+41763353828",
  waNumber: "41763353828",
  instagram: "https://www.instagram.com/hammergymlugano/",
  instagramHandle: "@hammergymlugano",
  street: "Via Fola 13",
  city: "6963 Lugano",
  mapsEmbed:
    "https://maps.google.com/maps?q=Via%20Fola%2013%2C%206963%20Lugano%2C%20Switzerland&t=&z=16&ie=UTF8&iwloc=&output=embed",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=Via%20Fola%2013%2C%206963%20Lugano%2C%20Switzerland",
  mapsSearch:
    "https://www.google.com/maps/search/?api=1&query=Hammer%20Gym%20Via%20Fola%2013%2C%206963%20Lugano",
  openHour: 6,
  closeHour: 22,
};

const BASE = `${process.env.PUBLIC_URL || ""}/images/`;

export const IMG = {
  interior: BASE + "sala-murale.jpg",
  badge: BASE + "hammer-strength-badge.jpg",
  mural: BASE + "macchine-arnold.jpg",
  athlete: BASE + "atleta-insegna.jpg",
  crew: BASE + "hammer-family.jpg",
  heroHd: BASE + "sala-murale-hd.jpg",
  muralHd: BASE + "macchine-arnold-hd.jpg",
};

// Prices (CHF). null = free, undefined/"request" = price on request. Edit here.
export const PRICES = {
  intro: null, // free
  quarterly: "request",
  semiannual: "request",
  annual: "request",
  pt: 80,
  dropin: 25,
};

export const waLink = (text) =>
  `https://wa.me/${SITE.waNumber}?text=${encodeURIComponent(text || "")}`;

// Returns {open:boolean, dayIndex:0..6 (Mon=0)} in Europe/Zurich
export const zurichNow = () => {
  try {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Zurich",
      weekday: "short",
      hour: "2-digit",
      hour12: false,
    }).formatToParts(new Date());
    const wd = parts.find((p) => p.type === "weekday")?.value;
    const hour = parseInt(parts.find((p) => p.type === "hour")?.value || "0", 10);
    const map = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    return { open: hour >= SITE.openHour && hour < SITE.closeHour, dayIndex: map[wd] ?? 0 };
  } catch {
    const d = new Date();
    const h = d.getHours();
    return { open: h >= 6 && h < 22, dayIndex: (d.getDay() + 6) % 7 };
  }
};
